import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "row q-col-gutter-md items-center" }
const _hoisted_3 = {
  class: "flex no-wrap items-center",
  style: {"gap":"12px"}
}
const _hoisted_4 = { class: "text-small text-bold" }
const _hoisted_5 = {
  class: "ellipsis-2-lines",
  style: {"word-break":"break-word"}
}
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { key: 1 }

import {computed, PropType} from 'vue';
import {Item} from 'src/models/market';
import {useSearchStore} from 'src/apps/search/store';
import {useRouter} from 'vue-router';


export default /*@__PURE__*/_defineComponent({
  __name: 'ItemDetailAttributes',
  props: {
  modelValue: {
    type: Object as PropType<Item>,
    required: true
  }
},
  setup(__props) {

const props = __props

const typeVal = computed(() => {
  let r = `${props.modelValue.item_type_display} - ${props.modelValue.offer_type_display}`
  return r
})

const rawAttributes = [
  {
    key: 'shipping',
    label: 'Versand',
    icon: 'forward_to_inbox',
    value: props.modelValue.shipping !== 'not_specified' ? props.modelValue.shipping_display : undefined
  },
  {
    key: 'condition',
    label: 'Zustand',
    icon: 'help_outline',
    value: props.modelValue.condition !== 'not_specified' ? props.modelValue.condition_display : undefined
  },
  {
    name: 'item_type',
    key: 'item_type',
    label: 'Anzeigenart',
    icon: 'list_alt',
    value: typeVal.value
  },
  {
    name: 'category',
    key: 'category',
    label: 'Kategorie',
    icon: 'category',
    value: props.modelValue?.categories.length ? props.modelValue?.categories : undefined
  }
]

const attributes = rawAttributes.filter(attribute => attribute.value)
const $router = useRouter()
const searchStore = useSearchStore()

function goToCat(category) {
  searchStore.updateFilterData({categories: category.id})
  $router.push({name: 'search', query: {t: 'market'}})
}


return (_ctx: any,_cache: any) => {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_card = _resolveComponent("q-card")!

  return (_unref(attributes)?.length)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_q_card, {
          flat: "",
          bordered: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_card_section, null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(attributes), (attribute) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: attribute.key,
                      class: "col-12 col-sm-6 col-md-4"
                    }, [
                      _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("div", null, [
                          _createVNode(_component_q_icon, {
                            color: "grey-7",
                            name: attribute.icon,
                            size: "1.5rem"
                          }, null, 8, ["name"])
                        ]),
                        _createElementVNode("div", null, [
                          _createElementVNode("div", _hoisted_4, _toDisplayString(attribute.label), 1),
                          _createElementVNode("div", _hoisted_5, [
                            (attribute.key === 'category')
                              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(attribute.value, (cat) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: cat.id
                                  }, [
                                    _createElementVNode("a", {
                                      href: "#",
                                      onClick: _withModifiers(($event: any) => (goToCat(cat)), ["prevent"])
                                    }, _toDisplayString(cat.name), 9, _hoisted_6)
                                  ]))
                                }), 128))
                              : (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(attribute.value), 1))
                          ])
                        ])
                      ])
                    ]))
                  }), 128))
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]))
    : _createCommentVNode("", true)
}
}

})